import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCloudServiceDetailsService } from '../../services';
import ControlQuestionCard from '../ComplianceReady/ControlQuestionCard';
import '../../styles/dashboardV2.scss';

const CloudServiceDetails = () => {
    const { controlId } = useParams();
    const navigate = useNavigate();
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchServiceDetails = async () => {
            try {
                const response = await getCloudServiceDetailsService(controlId);
                const data = response?.statusCode?.response_data?.data || null;
                setDetails(data);
            } catch (error) {
                console.error("Error fetching cloud service details:", error);
            } finally {
                setLoading(false);
            }
        };
        if (controlId) {
            fetchServiceDetails();
        }
    }, [controlId]);

    if (loading) {
        return (
            <div className="cloud-details-loading">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const findings = Array.isArray(details) ? details : [];
    const serviceName = findings.length > 0 ? findings[0].service : "Service Details";

    return (
        <div className="cloud-score-details">
            <div className="cloud-score-details__header">
                <button className="btn-back" onClick={() => navigate(-1)}>
                    ← Back
                </button>
                <div className="cloud-score-details__title-wrap">
                    <h2 className="cloud-score-details__title">{serviceName}</h2>
                    <p className="cloud-score-details__subtitle">Detailed findings for Service Name: {controlId}</p>
                </div>
            </div>

            <div className="cloud-service-details__content mt-4">
                {findings.length > 0 ? (
                    findings.map((finding, index) => (
                        <ControlQuestionCard
                            key={index}
                            title={finding.title}
                            description={finding.description}
                            itemId={finding.id}
                            service={finding.service}
                            status={finding.status === "PASS" ? "Pass" : finding.status === "FAIL" ? "Fail" : finding.status}
                            checkName={finding.event_code}
                            findingsMessage={`Resource: ${finding.resource} | Region: ${finding.region}`}
                        />
                    ))
                ) : (
                    <div className="text-center py-5">
                        <p className="text-muted">No findings found for this control.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CloudServiceDetails;
